
import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { CookieService } from '../services/cookie.service';


@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(private authService: AuthService, private router: Router, private cookieService: CookieService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const authToken = this.cookieService.getCookie("token");
    if(authToken){
      return true;
    }else{
      if (state.url.includes('asamblea')){
        sessionStorage.setItem('returnUrl', state.url);
      }
      this.router.navigate(['/login']);
      return false
    }
  }
}
